import { Search, Plus } from "lucide-react";
import Button from "@/shared/components/button";
import { ActionsDropdown } from "./actions_dropdown";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export function AccountsToolbar({ selectedIds, handleDeleteSelected, searchTerm, setSearchTerm }: { selectedIds: string[], handleDeleteSelected: () => void, searchTerm: string, setSearchTerm: (term: string) => void }) {

  const navigate = useNavigate();
  const [isActionsOpen, setIsActionsOpen] = useState(false);

  return (
    <div className="mt-10">
      <div className="flex flex-wrap items-center gap-4">
        <ActionsDropdown
          isOpen={isActionsOpen}
          selectedCount={selectedIds.length}
          onToggle={() => setIsActionsOpen(!isActionsOpen)}
          onDeleteSelected={handleDeleteSelected}
          onClearSelection={() => {
            setIsActionsOpen(false);
          }}
        />

        <div className="relative flex-1 min-w-75">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 size-4 text-foreground/40" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar por nombre, empresa, plan..."
            className="w-full bg-white/60 border border-black/5 backdrop-blur-sm rounded-xl py-2.5 pl-11 pr-4 text-sm font-medium text-foreground focus:outline-none focus:border-accent/30 focus:ring-4 focus:ring-accent/5 transition-all placeholder:text-foreground/30 shadow-sm"
          />
        </div>

        <Button
          className="h-11 px-6 rounded-xl bg-accent hover:bg-accent/90 text-white border-none shadow-[0_0_20px_rgba(12,123,254,0.3)] transition-all hover:scale-[1.02] active:scale-[0.98]"
          onClick={() => navigate("new")}
        >
          <Plus className="size-5" />
          <span className="font-bold">Añadir Sub-cuenta</span>
        </Button>
      </div>
    </div>
  );
}
